import React, { useEffect, useState } from "react";
import ContactBanner from "../components/contact/ContactBanner";
import { useLoader } from "../context/LoaderContext";
import { IBannerData, IContactFromData } from "../exports/interfaces";
import { dynamicFailed } from "../hooks/useToast";
import { fetchContactBanner, fetchContactFrom } from "../api/ContactApi";
import ContactForm from "../components/contact/ContactForm";
import ContactTiles from "../components/contact/ContactTiles";
import Map from "../components/contact/Map";

const Contact = () => {
  const { setLoading } = useLoader();
  const [contactBannerData, setContactBannerData] = useState<IBannerData[]>([]);
  const [contactFormData, setContactFromData] = useState<IContactFromData[]>(
    []
  );

  useEffect(() => {
    setLoading(true);
    Promise.all([fetchContactBanner(), fetchContactFrom()])
      .then(([contactBannerData, contactFromData]) => {
        setContactBannerData(contactBannerData);
        setContactFromData(contactFromData);
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        dynamicFailed("Server Error");
      });
  }, [setLoading]);
  return (
    <>
      <ContactBanner contactBannerData={contactBannerData} />
      <ContactForm contactFormData={contactFormData} />
      <ContactTiles contactFormData={contactFormData} />
      <Map />
    </>
  );
};

export default Contact;
